"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRepeatContext = void 0;
// @ts-nocheck
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const lodash_1 = __importDefault(require("lodash"));
const AlertDialog_1 = require("../Modals/AlertDialog");
const RepeatContext = react_1.default.createContext({
    toggleCollapse: () => { },
    repeatCollapsed: false,
    openDeleteConfirmation: (deleteItem, message) => { },
});
const RepeatWrapper = props => {
    const [opened, setOpened] = react_1.default.useState(true);
    const [confirmationMessage, setConfirmationMessage] = react_1.default.useState('');
    const deleteFn = react_1.useRef(lodash_1.default.noop);
    const toggleOpened = () => {
        setOpened(!opened);
    };
    const openDeleteConfirmation = (deleteItem, message) => {
        setConfirmationMessage(message);
        deleteFn.current = deleteItem;
    };
    const handleClose = (shouldDelete) => {
        setConfirmationMessage('');
        if (shouldDelete) {
            deleteFn.current();
        }
        deleteFn.current = lodash_1.default.noop;
    };
    // TODO - see what the form renderer can pass down to this wrapper as prop so this doesn't have to feel so hacky
    const firstFieldProp = react_1.useMemo(() => {
        if (props.children &&
            props.children[0] &&
            props.children[0].props.controlDefinition &&
            props.children[0].props.controlDefinition.type !== 'group') {
            return props.children[0].props;
        }
        return null;
    }, [props.children]);
    return (react_1.default.createElement(RepeatContext.Provider, { value: { toggleCollapse: toggleOpened, repeatCollapsed: !opened, openDeleteConfirmation } },
        firstFieldProp ? (react_1.default.createElement(core_1.Card, { style: { marginBottom: 20 } },
            react_1.default.createElement(core_1.CardContent, { style: { padding: 0 } },
                react_1.default.createElement("div", { style: { width: '100%' } }, props.children)))) : (props.children),
        confirmationMessage && (react_1.default.createElement(AlertDialog_1.AlertDialog, { title: confirmationMessage, cancelText: 'Cancel', okText: 'Delete', onCancelPress: () => handleClose(false), onOkPress: () => handleClose(true) }))));
};
const useRepeatContext = () => react_1.default.useContext(RepeatContext);
exports.useRepeatContext = useRepeatContext;
exports.default = RepeatWrapper;
//# sourceMappingURL=RepeatWrapper.js.map